import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
  gridData: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  createNewDD: {
    data: undefined,
    isLoading: false,
    hasError: false,
  },
  updateDD: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  deleteDD: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  configGroups: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  createConfigGroups: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  createNewDDValue: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  updateDDValue: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  deleteDDValue: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  searchValue: "",
  sortBy: "",
  selectedPage: 0,
  isTouched: false,
};

export const dataDescriptionReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.GET_DDS:
      return {
        ...newState,
        gridData: { ...newState.gridData, isLoading: true, hasError: false },
      };
    case actionTypes.GET_DDS_SUCCESS:
      return {
        ...newState,
        gridData: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_DDS_FAILURE:
      return {
        ...newState,
        gridData: { data: action.payload, isLoading: false, hasError: true },
      };
     
      case actionTypes.DELETE_DD:
        return {
          ...newState,
          deleteDD: { ...newState.deleteDD, isLoading: true, hasError: false },
        };
      case actionTypes.DELETE_DD_SUCCESS:
        return {
          ...newState,
          deleteDD: { data: action.payload, isLoading: false, hasError: false },
        };
      case actionTypes.DELETE_DD_FAILURE:
        return {
          ...newState,
          deleteDD: { data: action.payload, isLoading: false, hasError: true },
        };

    case actionTypes.GET_CONFIG:
      return {
        ...newState,
        configGroups: { ...newState.configGroups, isLoading: true, hasError: false }
      };
    case actionTypes.GET_CONFIG_SUCCESS:
      return {
        ...newState,
        configGroups: { data: [...action.payload], isLoading: false, hasError: false },
      };
    case actionTypes.GET_CONFIG_FAILURE:
      return {
        ...newState,
        configGroups: { ...newState.configGroups, isLoading: false, hasError: true },
      };

    case actionTypes.CREATE_NEW_DD:
      return {
        ...newState,
        createNewDD: {
          ...newState.createNewDD,
          isLoading: true,
          hasError: false,
        },
      };
    case actionTypes.CREATE_NEW_DD_SUCCESS:
      return {
        ...newState,
        createNewDD: {
          data: action.payload,
          isLoading: false,
          hasError: false,
        },
      };
    case actionTypes.CREATE_NEW_DD_FAILURE:
      return {
        ...newState,
        createNewDD: { data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.CREATE_NEW_CONFIG:
      return {
        ...newState,
        createConfigGroups: {
          ...newState.createConfigGroups,
          isLoading: true,
          hasError: false,
        },
      };
    case actionTypes.CREATE_NEW_CONFIG_SUCCESS:
      return {
        ...newState,
        createConfigGroups: {
          data: action.payload,
          isLoading: false,
          hasError: false,
        },
      };
    case actionTypes.CREATE_NEW_CONFIG_FAILURE:
      return {
        ...newState,
        createConfigGroups: { data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.CREATE_NEW_DD_VALUE:
      return {
        ...newState,
        createNewDDValue: {
          ...newState.createNewDDValue,
          isLoading: true,
          hasError: false,
        },
      };
    case actionTypes.CREATE_NEW_DD_VALUE_SUCCESS:
      return {
        ...newState,
        createNewDDValue: {
          data: action.payload,
          isLoading: false,
          hasError: false,
        },
      };
    case actionTypes.CREATE_NEW_DD_VALUE_FAILURE:
      return {
        ...newState,
        createNewDDValue: { data: action.payload, isLoading: false, hasError: true },
      };

    default:
      return { ...newState };
  }
};
